// extracted by mini-css-extract-plugin
export var modal = "_bh-0";